module.exports = "<my-data-display my-data=\"$$owner.data.myOwners\"\n  my-nature=\"'owner'\"\n  enable-badges=\"true\"\n  enable-buttons=\"true\"\n  enable-excel=\"true\"\n  enable-links=\"true\"\n  enable-local-search=\"true\"\n  enable-title=\"true\"\n  enable-back=\"true\">\n</my-data-display>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/owner/templates/home.html
// module id = 1507
// module chunks = 0